import { useTranslation } from 'react-i18next'

import { EMPTY_FUNCTION, EMPTY_OBJECT } from '../../../../constants/common'
import Text from '../../../Text'
import { GretaAIChatChatListItem } from '../GretaAIChatChatListItem'

import * as styles from './GretaAIChatChatListSection.module.css'

function GretaAIChatChatListSection({
  activeChatId,
  chatStatusById = EMPTY_OBJECT,
  locale,
  now,
  section,
  withRowActions = true,
  onSelectChat = EMPTY_FUNCTION,
}) {
  const { t } = useTranslation()

  return (
    <section className={styles.section}>
      <Text isSecondary Element='h2' className={styles.sectionTitle}>
        {t(section.titleKey)}
      </Text>
      <ul className={styles.items}>
        {section.chats.map(chat => (
          <GretaAIChatChatListItem
            chat={chat}
            isActive={chat.id === activeChatId}
            key={chat.id}
            locale={locale}
            now={now}
            status={chatStatusById[chat.id] ?? null}
            withRowActions={withRowActions}
            onSelect={onSelectChat}
          />
        ))}
      </ul>
    </section>
  )
}

export default GretaAIChatChatListSection
